import { FC } from "react";
import classNames from "classnames";
import { MultiValue, SingleValue } from "react-select";

import { useAppDispatch, useAppSelector, useSyncSelectedBrandToMain } from "../../hooks";
import { setViewBrandId } from "../../store/brands/slice";
import {
  selectActiveBrandsState,
  selectSelectedBrandState,
} from "../../store/selectors/brands";
import { createOptionsFromBrands } from "../../utils/createOptionsFromBrands";
import SelectCarma from "../Select/Select";
import { ISelectCarmaOption } from "../Select/types";
import { isSingleSelectOption } from "../Select/utils/isSingleSelectOption";
import Skeleton from "../Skeleton/Skeleton";
import { selectBrandEveryDay7dSummaryForBrand } from "@/store/selectors/scores";
import { BrandWithCompetitorsSelectProps } from "./types";

import styles from "./BrandWithCompetitorsSelect.module.css";



const BrandWithCompetitorsSelect: FC<BrandWithCompetitorsSelectProps> = ({
  className,
  onChange,
}) => {
  useSyncSelectedBrandToMain();

  const dispatch = useAppDispatch();
  const brandsWithCompetitors = useAppSelector(selectActiveBrandsState);
  const selectedBrand = useAppSelector(selectSelectedBrandState);
  const brand7dVisibilitySummaries = useAppSelector(selectBrandEveryDay7dSummaryForBrand);

  const options = createOptionsFromBrands(
    brandsWithCompetitors,
    brand7dVisibilitySummaries ?? undefined,
  );
  const selectedOption = options.find((o) => o.id === selectedBrand?.id);


  const handleChange = (newValue: SingleValue<ISelectCarmaOption> | MultiValue<ISelectCarmaOption>) => {
    if (!isSingleSelectOption(newValue)) return;

    const brand = brandsWithCompetitors?.find((b) => b.id === newValue.id);
    if (!brand) return;

    dispatch(setViewBrandId(brand.id));
    onChange?.(brand.id);
  };



  if (!brandsWithCompetitors?.length) {
    return <Skeleton className={className} height={48} />;
  }

  return (
    <div className={classNames(styles.brand_with_competitors_select, className)}>
      <SelectCarma value={selectedOption} options={options} onChange={handleChange} />
    </div>
  );
};

export default BrandWithCompetitorsSelect;
